var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsMain',[_c('WsCRUD',{attrs:{"modelName":_vm.modelName,"label":_vm.label,"fields":_vm.fields,"liveSearching":true,"showFields":_vm.showFields,"filterSelects":_vm.filterSelects,"pageMode":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }